module.exports = __webpack_public_path__ + "img/round-result.13b10216.png";